import React from 'react';
import PropTypes from 'prop-types';
import ResourceProperty from '../../../common/resource/ResourceProperty';
import EnumStatus from '../../../common/EnumStatus';
import {
  MAINTENANCE_RESET_RULE_DAY_OF_WEEK,
  MAINTENANCE_RESET_RULE_NTH_WEEKDAY,
  MAINTENANCE_RESET_RULE_TYPE,
  MAINTENANCE_RESET_RULE_TYPE_STATUS,
} from '../../../../config/constants';
import { tzNormalizeDate } from '../../../../utils/date';
import { DATE_FORMAT } from '../../../../config/locale';

const MaintenancePlanningResetRuleDisplay = ({
  rule,
  title = 'Regla de Reseteo',
}) => {
  if (!rule) return null;

  const renderRuleDetails = () => {
    switch (rule.maintenancePlanningResetRuleType) {
      case MAINTENANCE_RESET_RULE_TYPE.MONTH_RANGE.value:
        return (
          <>
            <ResourceProperty label="Día de inicio:">
              {rule.rangeStart || '-'}
            </ResourceProperty>
            <ResourceProperty label="Día de fin:">
              {rule.rangeEnd || '-'}
            </ResourceProperty>
          </>
        );

      case MAINTENANCE_RESET_RULE_TYPE.DAY_OF_MONTH.value:
        return (
          <ResourceProperty label="Día del mes:">
            {rule.dayOfMonth || '-'}
          </ResourceProperty>
        );

      case MAINTENANCE_RESET_RULE_TYPE.DAY_OF_WEEK.value:
        return (
          <>
            <ResourceProperty label="Día de la semana:">
              <EnumStatus
                enumObject={MAINTENANCE_RESET_RULE_DAY_OF_WEEK}
                enumValue={String(rule.weekday)}
              />
            </ResourceProperty>
          </>
        );

      case MAINTENANCE_RESET_RULE_TYPE.NTH_WEEKDAY.value:
        return (
          <>
            <ResourceProperty label="Día de la semana:">
              <EnumStatus
                enumObject={MAINTENANCE_RESET_RULE_DAY_OF_WEEK}
                enumValue={String(rule.weekday)}
              />
            </ResourceProperty>
            <ResourceProperty label="Semana del mes:">
              <EnumStatus
                enumObject={MAINTENANCE_RESET_RULE_NTH_WEEKDAY}
                enumValue={String(rule.weekNumber)}
              />
            </ResourceProperty>
          </>
        );

      default:
        return null;
    }
  };

  return (
    <div>
      <h3>{title}</h3>

      <ResourceProperty label="Tipo de regla:">
        <EnumStatus
          enumObject={MAINTENANCE_RESET_RULE_TYPE_STATUS}
          enumValue={rule.maintenancePlanningResetRuleType}
        />
      </ResourceProperty>

      {renderRuleDetails()}

      <ResourceProperty label="Fecha de creación:">
        {tzNormalizeDate({ date: rule.createDate, format: DATE_FORMAT })}
      </ResourceProperty>
    </div>
  );
};

MaintenancePlanningResetRuleDisplay.propTypes = {
  rule: PropTypes.shape({
    id: PropTypes.number,
    maintenancePlanningId: PropTypes.number,
    maintenancePlanningResetRuleType: PropTypes.string.isRequired,
    dayOfMonth: PropTypes.number,
    weekday: PropTypes.number,
    rangeStart: PropTypes.number,
    rangeEnd: PropTypes.number,
    createDate: PropTypes.number,
    weekNumber: PropTypes.number,
  }),
  title: PropTypes.string,
};

MaintenancePlanningResetRuleDisplay.defaultProps = {
  rule: null,
  title: 'Regla de Reseteo',
};

export default MaintenancePlanningResetRuleDisplay;
